import type { ReactNode } from "react";
import rawData from "../../src/data/setup.json";
import { useLayout } from "../contexts/layout-context";
import Layout01 from "../layouts/layout-01";
import Layout02 from "../layouts/layout-02";
import Layout03 from "../layouts/layout-03";
import type { Data } from "../types/data";

const setup: Data = rawData;

export default function DynamicLayout({ children }: { children: ReactNode }) {
	const { selectedLayout, isShowcaseMode } = useLayout();

	// Determina qual layout usar: se showcase mode, usa o selecionado; senão usa o do setup
	const layoutToUse = isShowcaseMode ? selectedLayout : setup.layout;

	switch (layoutToUse) {
		case 1:
			return <Layout01 data={setup}>{children}</Layout01>;
		case 2:
			return <Layout02 data={setup}>{children}</Layout02>;
		case 3:
			return <Layout03 data={setup}>{children}</Layout03>;
		default:
			return <div>Layout não encontrado</div>;
	}
}
